"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExpandableButton = void 0;
var _react = _interopRequireDefault(require("react"));
var _hooks = require("../../hooks");
var _Tooltip = require("../Tooltip");
var _ExpandableButton = _interopRequireDefault(require("./ExpandableButton.styles"));
var _toggleButton = require("./partials/toggleButton");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ExpandableButton = props => {
  const {
    btnTooltip,
    btnIconName,
    btnProps,
    openBtnProps,
    children,
    isWithMask = false,
    isWithTransition = false,
    isOpen = false,
    onBlockerClick
  } = props;
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const styles = (0, _ExpandableButton.default)(props);
  const handleButtonClick = event => {
    if (btnProps?.onClick) {
      btnProps.onClick(event);
    }
  };
  const handleBlockerClick = () => {
    if (onBlockerClick) {
      onBlockerClick();
    }
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-ExpandableButton'],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-ExpandableButton__content'],
        "data-testid": "ccExpandableButtonContent",
        "aria-hidden": !isOpen,
        children: children
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-ExpandableButton__btn'],
        children: btnTooltip && !isMobileView ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Tooltip.Tooltip, {
          isInteractive: true,
          position: "top",
          anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_toggleButton.ToggleButton, {
            btnProps: openBtnProps && isOpen ? openBtnProps : btnProps,
            btnIconName: btnIconName,
            isWithTransition: isWithTransition,
            isOpen: isOpen,
            onClick: handleButtonClick
          }),
          children: btnTooltip
        }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_toggleButton.ToggleButton, {
          btnProps: openBtnProps && isOpen ? openBtnProps : btnProps,
          btnIconName: btnIconName,
          isWithTransition: isWithTransition,
          isOpen: isOpen,
          onClick: handleButtonClick
        })
      })]
    }), isWithMask && isOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-ExpandableButton-mask'],
      onClick: handleBlockerClick
    })]
  });
};
exports.ExpandableButton = ExpandableButton;